const CURRENCY_CODE = 'VNĐ';

const CURRENCY_SYMBOL = 'đ';

const CURRENCY_MULTIPLIER = 1000;

const CURRENCY_INPUT_UNIT = '000 VNĐ';

export {
    CURRENCY_CODE,
    CURRENCY_SYMBOL,
    CURRENCY_MULTIPLIER,
    CURRENCY_INPUT_UNIT,
}
